import { Box } from '@chakra-ui/react';
import { PAGINATION_LIST_LIMIT } from 'lib/constants';
import React, { FunctionComponent } from 'react';
import { withTranslations } from 'store/translations';
import { transformedProperties } from 'utils/normalization/ankiroGroupedResults';
import { DocumentType } from 'utils/types/ankiro';

import { ListItem } from './listItem';

interface List {
  list: DocumentType[];
  totalItems: number;
  page: number;
}

export const List: FunctionComponent<List> = ({ list, totalItems, page }) => {
  const { common, category } = withTranslations();
  return (
    <Box>
      <Box
        textStyle={'desktop.body.book.s'}
        pb='xs'
        dangerouslySetInnerHTML={{
          __html: common('showingResults', {
            itemsShown: `${(page - 1) * PAGINATION_LIST_LIMIT + 1} - ${
              list.length < PAGINATION_LIST_LIMIT ? totalItems : page * PAGINATION_LIST_LIMIT
            }`,
            total: totalItems,
          }),
        }}
      />
      {list?.map((item) => {
        const data = transformedProperties(item.Properties);
        return (
          <ListItem
            key={item.Id}
            headline={data.Title}
            body={data.Description}
            image={data.image}
            category={category(data.Category)}
            url={data.Uri}
          />
        );
      })}
    </Box>
  );
};
